import { jsx as t } from "react/jsx-runtime";
import "react";
import { s as r } from "../../ResultsTable.module-B7M9y7hd.mjs";
function o({ columns: s = [] }) {
  return /* @__PURE__ */ t("div", { className: [r["results-table__row"], r["results-table__header-row"], "results-table__header-row"].join(" "), children: s.map((e) => /* @__PURE__ */ t(
    "div",
    {
      className: [
        r["results-table__header"],
        `results-table__${e.title.replace(" ", "-").toLowerCase()}`,
        "results-table__header"
      ].join(" "),
      children: e.title
    },
    `result-header-${e.title}`
  )) });
}
export {
  o as ResultsTableHeader,
  o as default
};
